import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { salesBootstrap } from './salesBootstrapSlice';

export const refreshAppBootstrap = createAsyncThunk<
    any,
    void,
    { state: RootState }
>(
    'bootstrap/refreshAppBootstrap',
    async (_, { dispatch, getState }) => {
        const state = getState();
        const role = getState().auth.role;

        if (!state.auth.isAuthorized) return;

        switch (role) {
            case 'sales':
                await dispatch(salesBootstrap()).unwrap();
                break;
            case 'manager':
                await dispatch(salesBootstrap()).unwrap();
                break;
            default:
                await dispatch(salesBootstrap()).unwrap();
        }
    }
);

interface BootstrapState {
    loading: boolean;
    error: string | null;
}

const initialState: BootstrapState = {
    loading: false,
    error: null,
};

const bootstrapSlice = createSlice({
    name: 'bootstrap',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(refreshAppBootstrap.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(refreshAppBootstrap.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(refreshAppBootstrap.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to bootstrap app';
            });
    },
});

export const bootstrapReducer = bootstrapSlice.reducer;